<template>
    <div class="mobile-navigation">
        <button @click="expanded = !expanded" class="p-2 text-white bg-black">
            <svg v-if="!expanded" class="w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
        <div
            :class="expanded ? '-translate-x-0' : '-translate-x-full'"
            class="fixed inset-y-0 left-0 w-4/5 h-screen py-4 overflow-auto transition duration-300 transform bg-gray-900"
        >
            <ul class="text-xs text-white">
                <li v-for="menuItem in menu.items" :key="menuItem.id">
                    <MobileItemWithChild v-if="menuItem.children.length > 0" :item="menuItem" />
                    <MobileItem v-else :item="menuItem" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import MobileItem from './MobileItem'
import MobileItemWithChild from './MobileItemWithChild'
export default {
    components: { MobileItem, MobileItemWithChild },
    props: ['menu'],
    data() {
        return {
            expanded: false
        };
    }
};
</script>

<style lang="scss">
.mobile-navigation {
    img {
        @apply w-6 mr-1;
    }
}
</style>
